__turbopack_context__.v({
  "button": "Button-module__dCAKMq__button",
  "content": "Button-module__dCAKMq__content",
});
